import React, { useEffect, useState } from 'react';
import {Drawer, Table} from 'antd';

import AddLookupDetails from 'modules/lookup_table/add_lookup_values/addLookupDetails';

const columns = [
    {
        title: "POSITION",
        dataIndex: "sort",
        key: "sort",
        width: "5%"
    },
    {
        title: "UNIT CODE",
        dataIndex: "unit_name",
        key: "unit_name",
        width: "30%"
    },
    {
        title: "DESCRIPTION",
        dataIndex: "unit_desc",
        key: "unit_desc",
        width: "35%"
    },
    {
        title: "DEFAULT",
        dataIndex: "default",
        key: "default",
        width: "5%"
    },
    {
        title: "DATE CREATED",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "15%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "10%"
    },
];

function SearchUnitsTable(props) {
    const { data, pageSize } = props;
    const [tableData, setTableData] = useState([]);
    const [tableValues, setTableValues] = useState(data);

    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };

    const onClose = () => { 
        setOpen(false); 
        // setTableData([]);
    };

    useEffect(()=> {
        setTableValues(data);
    }, [data])

    function setData(values) {
        setTableValues(values);
    }

    function refreshTblData(values) {
        console.log('check units refresh', values)
    }

    function updateDrawer(e) {
        setTableData(e)
        showDrawer();
    }

    function drawerClose(value) {
        setOpen(value);
    }
    
    return(
        <div>
            <Table
                style={ {textTransform: "uppercase"} }
                dataSource = {tableValues}
                columns={columns}
                bordered
                pagination={{ defaultPageSize: 5 }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => {updateDrawer(record)}
                    };
                }}
            />
            <Drawer title={"UPDATE " + props.lookupValue} placement="right" onClose={onClose}
                width="30%"
                visible={open}
            >
                <AddLookupDetails 
                    lookupDet={props.lookupValue} 
                    drawerClose={ drawerClose }
                    refreshTblData={ refreshTblData }
                    tableData={ tableData }
                    setData={ setData }
                />
            </Drawer>
        </div>
    )
}

export default SearchUnitsTable;